/**
 * site.js — the tree as a built site, zipped.
 *
 * The pages come from the engine's renderSite, the same code the CLI's build
 * runs, loaded on first use. The rest of a site — engine bundles, stylesheet,
 * vendor libs, envoy — is already served here, since this origin is itself a
 * built site; build.mjs lists those files in site-assets.json.
 */

import * as fs from './fs.js';
import { downloadZip } from './zip.js';

const MOUNT_PATH = '/_rvmark/';

async function fetchOk(path) {
  const res = await fetch(path);
  if (!res.ok) throw new Error(`${path}: ${res.status}`);
  return res;
}

/** Builds the site and hands it over as a download, unless `proceed` turns down the
 *  build's warnings. True once the zip is handed over. */
export async function saveSite(filename, proceed) {
  const [{ renderSite, contentOutDir }, assets, template] = await Promise.all([
    import('rvmark/build/browser'),
    fetchOk('/site-assets.json').then((r) => r.json()),
    fetchOk('/site-template.html').then((r) => r.text()),
  ]);

  const paths = fs.paths();
  const warnings = [];
  const warn = (line) => warnings.push(line.trim().replace(/^(warning:|⚠)\s*/, ''));
  const entries = [...renderSite({ paths, read: fs.read, template, mountPath: MOUNT_PATH, log: () => {}, warn })];
  if (warnings.length && !(await proceed(warnings))) return false;
  for (const path of paths) {
    if (!fs.isRvFile(path)) entries.push([contentOutDir(MOUNT_PATH) + '/' + path, fs.read(path) ?? await fs.blob(path)]);
  }
  for (const path of assets) {
    entries.push([path, new Uint8Array(await (await fetchOk('/' + path)).arrayBuffer())]);
  }
  await downloadZip(filename, entries);
  return true;
}
